<p *ngIf="show" class="title">
  Loading...
</p>
